import React from 'react'
const CTA = () => {
  return (
    <div className='cta'>
        <a href='https://drive.google.com/file/d/1ngsOSKkFicuBMnWz-mVSpXQ1H7dhg4Xd/view?usp=sharing' target="_blank" className='btn' rel="noreferrer">Download CV</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA